// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"249f249d","453":"b51c697c","796":"ebee106d"}[chunkId] + ".chunk.js";
};